import React from 'react';
import { Accordion, DrawFeature } from '@agissc/ktag-map';
import useAppState from '../../../AppStore';
import { AccordionName } from '../../../UIStateSlice';
import DrawListElement from './DrawListElement';
import DrawListTool from './DrawListTool';

interface DragHandleProps {
  listeners: Record<string, unknown>;
  attributes: Record<string, unknown>;
}

interface DrawAccordionItemProps {
  drawFeature: DrawFeature;
  isSelected: boolean;
  isHovered: boolean;
  isDragOverlay: boolean;
  dragHandleProps?: DragHandleProps;
}

const emptyDragHandleProps = { listeners: {}, attributes: {} };

export const DrawAccordionItem = ({
  drawFeature,
  isSelected,
  isHovered,
  isDragOverlay,
  dragHandleProps,
}: DrawAccordionItemProps) => {
  const expanded = useAppState(
    (state) =>
      !!state.accordions[AccordionName.DRAW_CONFIGURATION]?.find(
        (i) => i.id === drawFeature.id && i.expanded,
      ),
  );
  const setAccordionItem = useAppState((state) => state.setAccordionItem);
  const setHoveredFeatureId = useAppState((state) => state.setHoveredFeatureId);

  const onToggle = (isExpanded: boolean) => {
    setAccordionItem(
      AccordionName.DRAW_CONFIGURATION,
      String(drawFeature.id!),
      isExpanded,
    );
  };

  const getAdditionalClassNames = () => {
    const classes: string[] = [];
    if (isDragOverlay) classes.push('accordion__dnd');
    if (isSelected) classes.push('configuration__item--active');
    return classes.length > 0 ? classes.join(' ') : undefined;
  };

  const accordionProps = isDragOverlay
    ? { dragHandleProps: emptyDragHandleProps }
    : { onToggle, dragHandleProps };

  const handleOnMouseEnter = () => {
    setHoveredFeatureId(drawFeature.id as string);
  };

  const handleOnMouseLeave = () => {
    setHoveredFeatureId(null);
  };

  return (
    <Accordion
      key={`${drawFeature.id}-${expanded}`}
      title={<DrawListTool feature={drawFeature} isHovered={isHovered} />}
      openIcon="chevron-down"
      closedIcon="chevron-up"
      open={expanded}
      additionalClassNames={getAdditionalClassNames()}
      disableTitleToggle
      onMouseEnter={handleOnMouseEnter}
      onMouseLeave={handleOnMouseLeave}
      {...accordionProps}
    >
      <DrawListElement feature={drawFeature} />
    </Accordion>
  );
};
